export default __webpack_public_path__ + "static/media/star 1.344ccbf9.svg";